import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { Actions } from 'components/Actions';

export const useColumns = () =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Seasons',
        columns: [
          {
            Header: 'Name',
            accessor: 'season',
          },
          {
            accessor: 'actions',
            disableSortBy: true,
            Cell: () => <Actions isEditPath hasDelete tableName="seasons" toTheRight />,
          },
        ],
      },
    ],
    []
  );
